export default __webpack_public_path__ + "static/media/image-product.69ed79fd.jpg";